import AuthService from "../../services/auth";
import ROUTES from "../../configs/routesConfig";
import { useGetRole } from "./getRole";
import { useMemo } from "react";
import { useHasDashBoardAccess } from "../PermissionContainer/hooks/useHasDashboardAccess";
import USER_ROLES from "../../types/UserRoles";

export const useLogoRedirectPath = () => {
  const { canViewDashboard } = useHasDashBoardAccess();

  const [role] = useGetRole();

  const logoRedirectPath: string = useMemo(() => {
    const isLoggedIn = AuthService.isLoggedIn();

    let path: string;

    if (isLoggedIn && role) {
      if (role === USER_ROLES.INTEGRATION_RECEPTIONIST) {
        path = ROUTES.PROFILE;
      } else {
        path =
          ![USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(role) ||
          !canViewDashboard
            ? ROUTES.ACCOUNTS
            : ROUTES.DASHBOARD;
      }
    } else {
      path = ROUTES.LOGIN;
    }

    return path;
  }, [role, canViewDashboard]);

  return { logoRedirectPath };
};
